var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9981 12.8619C19.9981 17.2802 16.4164 20.8619 11.9981 20.8619C7.57983 20.8619 3.99811 17.2802 3.99811 12.8619C3.99811 8.44366 7.57983 4.86194 11.9981 4.86194C16.4164 4.86194 19.9981 8.44366 19.9981 12.8619ZM21.9981 12.8619C21.9981 18.3848 17.521 22.8619 11.9981 22.8619C6.47526 22.8619 1.99811 18.3848 1.99811 12.8619C1.99811 7.33909 6.47526 2.86194 11.9981 2.86194C17.521 2.86194 21.9981 7.33909 21.9981 12.8619ZM11.4981 17.8619C11.222 17.8619 10.9981 17.6381 10.9981 17.3619V13.8619H7.49811C7.22197 13.8619 6.99811 13.6381 6.99811 13.3619V12.3619C6.99811 12.0858 7.22197 11.8619 7.49811 11.8619H10.9981V8.36194C10.9981 8.0858 11.222 7.86194 11.4981 7.86194H12.4981C12.7743 7.86194 12.9981 8.0858 12.9981 8.36194V11.8619H16.4981C16.7743 11.8619 16.9981 12.0858 16.9981 12.3619V13.3619C16.9981 13.6381 16.7743 13.8619 16.4981 13.8619H12.9981V17.3619C12.9981 17.6381 12.7743 17.8619 12.4981 17.8619H11.4981Z",
    fill: "#003C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.14cff1304d7a0323ee039d1076fd52d9.svg";
export { ForwardRef as ReactComponent };